import { Toaster as Sonner } from "sonner"
import './sonner-layout.css'

const Toaster = ({ ...props }) => {
  return (
    <Sonner
      theme="dark"
      className="toaster group app-toast-layout"
      data-testid="app-toaster"
      position="top-center"
      toastOptions={{
        duration: 2500,
        classNames: {
          toast:
            "group toast group-[.toaster]:text-accent group-[.toaster]:border group-[.toaster]:border-accent/30 group-[.toaster]:rounded-2xl group-[.toaster]:font-heading group-[.toaster]:font-bold group-[.toaster]:uppercase group-[.toaster]:tracking-wide group-[.toaster]:text-sm",
          description: "group-[.toast]:text-[#C7C9CE] group-[.toast]:font-sans group-[.toast]:normal-case group-[.toast]:tracking-normal group-[.toast]:font-medium group-[.toast]:text-xs",
          actionButton:
            "group-[.toast]:bg-accent group-[.toast]:text-accent-foreground group-[.toast]:font-bold group-[.toast]:rounded-full",
          cancelButton:
            "group-[.toast]:bg-white/10 group-[.toast]:text-[#C7C9CE] group-[.toast]:rounded-full",
          success:
            "group-[.toaster]:border-accent/30",
          error:
            "group-[.toaster]:text-red-400 group-[.toaster]:border-red-500/30 group-[.toaster]:shadow-[0_4px_20px_rgba(239,68,68,0.1)]",
        },
      }}
      {...props}
    />
  )
}

export { Toaster }
